import { combineReducers } from 'redux'

let user = JSON.parse(localStorage.getItem('user'));

const INITIAL_STATE = user ? { loggedIn: true } : {};

const applySetAuthUser = (state, action) => ({
    ...state,
    authUser: action.authUser,
  });


  function sessionReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
      case 'AUTH_USER_SET': 
        return { ...state,
          authUser: action.authUser};
      default:
        return state;
    }
  }
  export default sessionReducer;